export enum CreditAuthorizationDecision {
  Accept = 1,
  Decline = 2,
}
